import { BrowserRouter, Route, Routes } from 'react-router';
import Dashboard from '../pages/Dashboard.jsx';
import RouterRootComponent from './RouterRootComponent.jsx';
import PageNotFound from '~/components/PageNotFound.jsx';

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RouterRootComponent />}>
          <Route
            path="/"
            element={<Dashboard />}
          />
          <Route
            path="*"
            element={<PageNotFound />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
